import React from "react";
import { MdOutlineCalendarToday } from "react-icons/md";
import Card from "Components/Common/Card";
import LineChart from "Components/charts/LineChart";
import { FaUsers } from "react-icons/fa6";

const TotalSpent = ({ engagedHearts = 0, idleHearts = 0 }) => {
  const series = [
    {
      name: "Engaged",
      data: [engagedHearts, engagedHearts + 10, engagedHearts + 5, engagedHearts + 8, engagedHearts + 3, engagedHearts],
      color: "#d5549f",
    },
    {
      name: "Idle",
      data: [idleHearts, idleHearts + 5, idleHearts - 3, idleHearts + 7, idleHearts - 2, idleHearts],
      color: "#5068ef",
    },
  ];

  return (
    <Card extra="!p-[20px] text-center">
      <div className="flex justify-between">
        <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-[#f8e6ef] p-2 text-gray-700">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-gray-700">This month</span>
        </button>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-[#f8e6ef] p-2 text-[#c51369]">
          <FaUsers className="h-6 w-6" />
        </button>
      </div>

      <div className="flex flex-col h-full w-full justify-between">
        <div className="h-full w-full">
          <LineChart series={series} />
        </div>
        <p className="mt-2 text-sm text-gray-700 font-semibold tracking-wide text-center">
          Ratio of Engaged & Idle Users
        </p>
      </div>
    </Card>
  );
};

export default TotalSpent;
